module.exports = __webpack_public_path__ + "img/nagad.63188bd7.png";